var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFloatingMembership = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.79 5.486h-6.58a2.22 2.22 0 0 0-2.218 2.215v6.58c0 1.222.99 2.214 2.218 2.214h6.57A2.215 2.215 0 0 0 22 14.28V7.692c0-1.213-.981-2.206-2.2-2.206",
  fill: "#21AB73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.798 5.505h-6.58A2.215 2.215 0 0 0 0 7.72v6.579c0 1.222.99 2.215 2.218 2.215h6.57a2.215 2.215 0 0 0 2.218-2.215V7.71c0-1.213-.98-2.205-2.199-2.205",
  fill: "#1A2E80"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.18 14.226c0 .395-.321.716-.715.716a.717.717 0 0 1 0-1.433c.394 0 .715.321.715.717Z",
  fill: "#2E80FF"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.808 11.717a.786.786 0 0 0-.587.303c-.366.432-.87.763-1.512.763a1.79 1.79 0 0 1-1.796-1.774c0-.946.77-1.773 1.796-1.773.65 0 1.146.34 1.512.762.12.157.358.304.587.304.43 0 .724-.322.724-.68a.725.725 0 0 0-.12-.423c-.586-.864-1.52-1.406-2.703-1.406-1.824 0-3.244 1.406-3.244 3.216 0 1.81 1.42 3.216 3.244 3.216 1.173 0 2.117-.55 2.704-1.405a.725.725 0 0 0 .119-.423c0-.359-.294-.68-.724-.68Z",
  fill: "#fff"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.18 14.226c0 .395-.321.716-.715.716a.717.717 0 0 1 0-1.433c.394 0 .715.321.715.717Z",
  fill: "#2E80FF"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.496 7.793a.717.717 0 0 0-.715.717v4.98c0 .396.321.717.715.717a.717.717 0 0 0 .715-.717V8.51a.717.717 0 0 0-.715-.717Z",
  fill: "#fff"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.698 10.991a.717.717 0 0 0-.715-.717h-4.967a.717.717 0 0 0 0 1.434h4.967a.717.717 0 0 0 .715-.717Z",
  fill: "#fff"
})));
export default SvgIconFloatingMembership;